module.exports = __webpack_public_path__ + "static/media/buy.f2714301.svg";